let cosl:{el:HTMLElement,handler:()=>void}[]=[];
export function AddClickOutsideListener(el:HTMLElement, handler:()=>void):void {
  cosl.push({el,handler});
}
export function RemoveClickOutsideListener(el:HTMLElement, handler:()=>void):boolean {
  for(let i=0;i<cosl.length;i++) {
    if(cosl[i].el===el && cosl[i].handler===handler) {
      cosl.splice(i,1);
      return true;
    }
  }
  return false;
}

document.addEventListener('click', e=> {
      for(let i=cosl.length-1;i>=0;i--) {
        if(!IsInside(e.target as Node,cosl[i].el)) cosl[i].handler();
      }
    },true);
function IsInside(inner:Node,outer:Node):boolean {
  while(inner) {
    if(inner===outer) return true;
    inner=inner.parentNode;
  }
  return false;
}
